//It will check the items in the cart
$(function () {
  cartCheck();
});

function addOrChangeCart(command, body) {
  if (command === "add") {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then(() => {
        location.reload();
      })
      .catch((error) => console.error(error));
  } else if (command === "change") {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        console.log(await response.json());
      })
      .then(() => {
        location.reload();
      })
      .catch((error) => console.error(error));
  } else {
    console.error("addOrChangeCart did not run. Invalid command.");
    return;
  }
}

function checkPromotionDate(startDate, endDate, currentDate) {
  if (currentDate >= startDate && currentDate < endDate) {
    return true;
  } else {
    return false;
  }
}

function sept26Promotion(cart) {
  const priceValidation = cart.items_subtotal_price >= 1000000;
  const alreadyAdded = cart.items.some((item) => item.sku === 'RN-N-RM');

  if (priceValidation && alreadyAdded === false
  ) {
    addOrChangeCart("add", {
      id: '39428538957888',
      quantity: 1,
    });
  } else if (!priceValidation && alreadyAdded === true) {
    addOrChangeCart("change", {
      line:
        cart.items.findIndex(
          (item) => item.sku === 'RN-N-RM'
        ) + 1,
      quantity: cart.items.find((item) => item.sku === 'RN-N-RM').quantity - 1,
    });
  }
}

function validateDecemberPromotionCart(cart) {
  const promotionSku = [
    "APNU-N-CM-N11",
    "APNU-N-CM-N8",
    "APNU-N-CM-N9",
    "APNU-N-CM-V32",
    "APNU-S-CL-N11",
    "APNU-S-CL-N8",
    "APNU-S-CL-N9",
    "APNU-S-CL-V32",
  ];
  const subtotal = cart.items_subtotal_price / 100;
  let itemDiscount = 0;
  cart.items.forEach((item) => {
    if(item.line_price == 0){
      if (promotionSku.includes(item.sku)) {
      itemDiscount += item.quantity;
    }
    }
    
  });
  
  console.log(itemDiscount)
  if (subtotal>=10000 && itemDiscount == 0) {
    return {
      renderPage: true,
      qualifyFreeItem : 1
    };
  }
  return {
    renderPage: false,
  };
}

async function getAvailablePromotionItems() {
  const {variants} = await (await fetch("/products/copy-of-hypnogel-individual-colors.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })).json();
  const promotionSku = variants.filter((variant) => variant.available).map((variant) => variant.id);
  return promotionSku[Math.floor(Math.random()*promotionSku.length)];
}




async function bfPromo2023(cart){
  const availablePromotionItem = await getAvailablePromotionItems();
  const hypnoAdded = cart.items.some((item) => item.properties._freeHypno);
  if(cart.items_subtotal_price >= 10000 && hypnoAdded === false){
      addOrChangeCart("add", {
        'id': availablePromotionItem,
        'quantity': 1,
        properties: {
        '_freeHypno': true
      }
    });
  }else if(cart.items_subtotal_price < 10000 && hypnoAdded === true){
      addOrChangeCart("change", {
        line: 
          cart.items.findIndex(
            (item) => item.properties._freeHypno
          ) + 1,
          quantity: cart.items.find((item) => item.properties._freeHypno).quantity - 1,
      });
   }

   let freePouch = 0;
   for(let i of cart.items){
      if(i.id === 39905033125952 && i.properties._freePouch){
        freePouch += i.quantity;
      }
   }
   const gelSku = cart.items.filter(item => item.sku.startsWith("APGC"));
   const totalQuantity = gelSku.reduce((accumulator, currentItem) => accumulator + currentItem.quantity, 0);
   const totalQualifyPouch = Math.floor(totalQuantity/5);
   if(freePouch<totalQualifyPouch){
      addOrChangeCart("add", {
        'id': 39905033125952,
        'quantity': totalQualifyPouch - freePouch,
        properties: {
        '_freePouch': true
      }
    });
   }else if(freePouch>totalQualifyPouch){
      addOrChangeCart("change", {
        line: 
          cart.items.findIndex(
            (item) => item.properties._freePouch
          ) + 1,
          quantity: cart.items.find((item) => item.properties._freePouch).quantity - 1,
      });
   }
  



   
}
async function cleanUpCart(Cart) {
  const hypnoAdded = Cart.items.some((item) => item.properties._freeHypno);
  const pouchAdded = Cart.items.some((item) => item.properties._freePouch);

  if(hypnoAdded || pouchAdded){
  await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      line: Cart.items.findIndex(
          (item) => item.properties._freePouch
        ) + 1,
        quantity: 0
    })
  })
  await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      line: Cart.items.findIndex(
          (item) => item.properties._freeHypno
        ) + 1,
        quantity: 0
    })
  })
  location.reload();
  }
}


function cartCheck() {
  jQuery.getJSON("/cart.js", function (Cart) {
    
    let myTime = new Date().getTime();

    let validateDecemberPromotion = validateDecemberPromotionCart(Cart);
    // start date 11/21/2023 4:00 pm PST 1700611200000
    // end date 11/26/23 7:59AM PST 1701053940000
    if (myTime >= 1700611200000 && myTime < 1701053940000) {
      bfPromo2023(Cart)
    }else{
      cleanUpCart(Cart);
    }
 
    
    if (
      checkPromotionDate(1671667200000, 1671980400000, myTime) &&
      validateDecemberPromotion.renderPage
    ) {
      // Japan BAGO December 2022
      const bagoItems = [
        "gel-x™-neutrals-lila-natural-coffin-medium-box-of-tips-150pcs",
        "gel-x™-neutrals-natural-coffin-medium-maisie",
        "gel-x™-neutrals-alex-natural-coffin-medium-box-of-tips-150pcs",
        "gel-x™-neutrals-mia-natural-coffin-medium-box-of-tips-150pcs",
        "gel-x™-neutrals-lila-sculpted-coffin-long-box-of-tips-150pcs",
        "gel-x™-neutrals-alex-sculpted-coffin-long-box-of-tips-150pcs",
        "gel-x™-neutrals-sculpted-maisie-coffin-long",
        "gel-x™-neutrals-mia-sculpted-coffin-long-box-of-tips-150pcs",
      ];
      bagoItems.forEach((slug) =>
        fetch(`/products/${slug}.js`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then(({ available, images, title, variants }) => {
            if (available) {
              const container = document.createElement("div");
              console.log(container);
              container.className = "product";
              container.innerHTML = `
           <img src="${images[0]}" height="50" width="50" />
           <p>${title}</p>
          `;
              const button = document.createElement("div");
              button.className = "btn";
              button.dataset.id = variants[0].id;
              button.innerText = "Select";
              button.addEventListener("click", () => {
                button.innerText = "Adding...";
                fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    id: variants[0].id,
                    quantity: 1,
                  }),
                })
                  .then((res) => res.json())
                  .then((data) => {
                    location.reload();
                  })
                  .catch((error) => {
                    button.innerText = "ERROR";
                    console.log(error);
                  });
              });
              container.append(button);
              const parent = document.getElementById("jp-bago-dec-22");
              parent.appendChild(container);
              const message = document.querySelector(
                "#jp-bago-dec-22 .message"
              );
              message.innerText = `Add ${validateDecemberPromotion.qualifyFreeItem} Gift${
                validateDecemberPromotion.qualifyFreeItem > 1 ? "s" : ""
              }`;
            }
          })
          .catch((error) => console.error(error))
      );
      $("#jp-bago-dec-22").show();
    } else {
      $("#jp-bago-dec-22").hide();
    }
    

    var cartItems = Cart.items;
    var artinkCounter = 0;
    var blCounter = 0;
    var gelxKitCounter = 0;
    var gelxBoxCounter = 0;
    var yokoKitCounter = 0;
    var yokoBoxCounter = 0;
    var chaunKitCounter = 0;
    var chaunBoxCounter = 0;
    var jennyKitCounter = 0;
    var jennyBoxCounter = 0;
    var artink;
    var gelxkit;
    var yokokit;
    var chaunkit;
    var jennykit;

    //PreOrder Sale Functionality
    let preOrderBaseSku = "APGXSET-FM";
    let preOrderSubSku = ["APGX-FM-SCL", "APGX-FM-NCM", "APGX-FM-NRS"];
    let numberOfSub = 0;
    let numberOfBase = 0;
    let totalCartQuantity = 0;
    let totalPreOrderQuantity = 0;

    //         PreOrder Error Message
    var PreOrderMessage = `<div id='popUp' style='text-align:center'>
                 <div id='popUpContainer'>
                    <h1>Oops! There seems to be a problem</h1>
                    <p>You are seeing this error because of the following</p>
                    <div id='notice'>
                      <h4>Please make sure that your cart:</h4>
                       <ul>
                          <li>French Manicure Gel-X Kit includes a selection of one of our French Gel-X Tips</li>
                       </ul>
                    </div>
                    <a class='button' href='#' id='close'>Ok</a>
                 </div>
              </div>`;

    for (i = 0; i < cartItems.length; i++) {
      for (j = 0; j < preOrderSubSku.length; j++) {
        if (cartItems[i].sku == preOrderSubSku[j]) {
          numberOfSub += cartItems[i].quantity;
          totalPreOrderQuantity += cartItems[i].quantity;
        }
      }
      if (cartItems[i].sku == preOrderBaseSku) {
        numberOfBase = cartItems[i].quantity;
        totalPreOrderQuantity += cartItems[i].quantity;
      }

      totalCartQuantity += cartItems[i].quantity;
    }

    $.each(cartItems, function (index, value) {
      if (this.sku.match(/APARTINK/g)) {
        for (i = 0; i < this.quantity; i++) {
          artinkCounter++;
        }
      }

      if (this.sku == "BL120") {
        for (i = 0; i < this.quantity; i++) {
          blCounter++;
        }
      }

      if (this.sku == "APGXSET-G3") {
        for (i = 0; i < this.quantity; i++) {
          gelxKitCounter++;
        }
      }

      if (this.sku.match(/AP-TIP/g)) {
        for (i = 0; i < this.quantity; i++) {
          gelxBoxCounter++;
        }
      }

      if (this.sku.match(/YO-B|YO-V/g)) {
        for (i = 0; i < this.quantity; i++) {
          yokoBoxCounter++;
        }
      }

      if (this.sku === "APGXSET-YO") {
        for (i = 0; i < this.quantity; i++) {
          yokoKitCounter++;
        }
      }

      if (this.sku === "APGXSET-CP") {
        for (i = 0; i < this.quantity; i++) {
          chaunKitCounter++;
        }
      }
      if (this.sku === "CP-TCXL") {
        for (i = 0; i < this.quantity; i++) {
          chaunBoxCounter++;
        }
      }
      if (this.sku === "APGXSET-JQ") {
        for (i = 0; i < this.quantity; i++) {
          jennyKitCounter++;
        }
      }
      if (this.sku === "JQ-SSTXXXL") {
        for (i = 0; i < this.quantity; i++) {
          jennyBoxCounter++;
        }
      }

      //              if (this.id === 31430312394810) {

      //                 for (i = 0; i < this.quantity; i++) {
      //                     free++
      //                 }

      //              array.push(this.price)
    });

    //     if (artinkCounter != 0) {
    //       if (artinkCounter <= blCounter) {
    //         artink = true;
    //       } else {
    //         artink = false;
    //       }
    //     } else {
    //       artink = "none in cart";
    //     }

    if (gelxKitCounter != 0) {
      if (gelxKitCounter <= gelxBoxCounter) {
        gelxkit = true;
      } else {
        gelxkit = false;
      }
    } else {
      gelxkit = "none in cart";
    }

    if (yokoKitCounter != 0) {
      if (yokoKitCounter <= yokoBoxCounter) {
        yokokit = true;
      } else {
        yokokit = false;
      }
    } else {
      yokokit = "none in cart";
    }

    if (chaunKitCounter != 0) {
      if (chaunKitCounter <= chaunBoxCounter) {
        chaunkit = true;
      } else {
        chaunkit = false;
      }
    } else {
      chaunkit = "none in cart";
    }
    if (jennyKitCounter != 0) {
      if (jennyKitCounter <= jennyBoxCounter) {
        jennykit = true;
      } else {
        jennykit = false;
      }
    } else {
      jennykit = "none in cart";
    }
    if (
      artink === false ||
      gelxkit === false ||
      yokokit === false ||
      chaunkit === false ||
      jennykit === false
    ) {
      
      popUp();

      $('input[type="submit"][value="レジへ進む"]').attr({
        disabled: "true",
      });
      $("#dynamic-checkout-cart").css("display", "none");
      $(".additional-checkout-buttons").css("display", "none");
      $(".info__tax").append(
        "<p class='error-msg' style='color:red !important;font-weight:700'>Error Code: E1000</p>"
      );
    } else if (numberOfBase > numberOfSub) {
      popUp(PreOrderMessage);

      $('input[type="submit"][id="Checkout"]').attr({
        disabled: "true",
      });
      $("#dynamic-checkout-cart").css("display", "none");

      $(".info__tax").append(
        "<p class='error-msg' style='color:red !important;font-weight:700'>Error Code: E1000</p>"
      );
    } else {
      // console.log("there is no false")
      $(".error-msg").remove();
      $("#dynamic-checkout-cart").css("display", "");
      $(".additional-checkout-buttons").css("display", "");
    }

    //       var sum = array.reduce(function(a, b){return a + b;}, 0);

    //         if (parseInt(sum) > parseInt("5000")){

    //           if (parseInt(free) === 0){
    //           	promo()
    //           } else {

    //          console.log('Only Once')
    //           }

    //         } else if(parseInt(sum) === 0) {

    //         Shopify.clear()

    //         }
  });

  //Create a popup overlay with a warning message
  function popUp() {
    overlayFn();

    function overlayFn() {
      var isMobile = window.matchMedia(
        "only screen and (max-width: 728px)"
      ).matches;

      console.log("Check to see if it is mobile: " + isMobile);

      if (isMobile) {
        console.log("It is mobile");

        $(".error-msg").remove();

        var docHeight = $(document).height();

        $("body").append("<div id='overlay'></div>");

        $("#overlay").height(docHeight).css({
          opacity: 0.4,
          position: "absolute",
          top: 0,
          left: 0,
          "background-color": "black",
          width: "100%",
          "z-index": 5000,
        });

        $("body").append(
          `<div id='popUp' style='text-align:center'><div id='popUpContainer'><h1>エラー</h1><p>このエラーは次のような場合に表示されます。</p><div id='notice'><ul><li>GEL-Xキットに対してチップBOXの数が満たない場合【GEL-XキットはチップBOXがセットになっておりますのでキットと同数又は、それ以上のチップを選択してください】
          </li><li>ArtMe x Aprés Gel-Xキットに対してチップBOXの数が満たない場合
          【ArtMe x Après Gel-XキットはチップBOXがセットになっておりますのでキットと同数又は、それ以上のチップを選択してください】
          </li><li>アートインクセットに対してブレンディングリキッドの数が満たない場合
【アートインクセットはブレンディングリキッドがセットになっておりますので、セットと同数又は、それ以上のブレンディングリキッドを選択してください。】
</li></ul></div><a href='#' class='button' id='close'>Ok</a></div></div>`
        );

        $("#popUp").css({
          position: "absolute",
          top: "15%",
          left: "15px",
          right: "15px",
          "background-color": "white",
          "margin-left": "auto",
          "margin-right": "auto",
          "z-index": 5001,
        });

        $("#notice").css({
          "text-align": "left",
          "z-index": 5001,
        });

        $("#popUpContainer").css({
          padding: "15px",
        });

        $("a[id$='close']").click(function () {
          $("#popUp").remove();
          $("#overlay").removeAttr("style");
          $("#popUp").empty();
        });
      } else if (!isMobile) {
        console.log("It is not mobile");
        $(".error-msg").remove();
        $("#popUp").remove();
        $("#overlay").removeAttr("style");
        var docHeight = $(document).height();

        $("body").append("<div id='overlay'></div>");

        $("#overlay").height(docHeight).css({
          opacity: 0.4,
          position: "absolute",
          top: 0,
          left: 0,
          "background-color": "black",
          width: "100%",
          "z-index": 5000,
        });

        $("body").append(
          `<div id='popUp' style='text-align:center'><div id='popUpContainer'><h1>エラー</h1><p>このエラーは次のような場合に表示されます。</p><div id='notice'><ul><li>GEL-Xキットに対してチップBOXの数が満たない場合 [GEL-XキットはチップBOXがセットになっておりますのでキットと同数又は、それ以上のチップを選択してください] 
          </li><li>ArtMe x Aprés Gel-Xキットに対してチップBOXの数が満たない場合
          【ArtMe x Après Gel-XキットはチップBOXがセットになっておりますのでキットと同数又は、それ以上のチップを選択してください】
          </li><li>アートインクセットに対してブレンディングリキッドの数が満たない場合
【アートインクセットはブレンディングリキッドがセットになっておりますので、セットと同数又は、それ以上のブレンディングリキッドを選択してください。】
</li></ul></div><a href='#' class='button' id='close'>Ok</a></div></div>`
        );

        $("#popUp").css({
          position: "absolute",
          top: "20%",
          left: 0,
          right: 0,
          "background-color": "white",
          width: "50%",
          "margin-left": "auto",
          "margin-right": "auto",
          "z-index": 5001,
        });

        $("#notice").css({
          "text-align": "left",
          "z-index": 5001,
        });

        $("#popUpContainer").css({
          padding: "15px",
        });

        $("a[id$='close']").click(function () {
          $("#popUp").remove();
          $("#overlay").removeAttr("style");
          $("#popUp").empty();
        });
      } //end else if
    }
  }
}

// function promo(){
// jQuery.post('/cart/add.js', {
//   items: [
//     {
//       quantity: 1,
//       id: 31430312394810

//     }
//   ]
// },);}

// $('tr[data-variant-id^="31430312394810"] a').removeAttr("href")
// $('span[data-line-key^="31430312394810:009a5ece200fd5d06a287c00f85994d1"]').remove();
// $('span[data-variant^="31430312394810"]').remove();
// document.getElementById("updates_31430312394810").disabled = true;
